import { createFileRoute } from '@tanstack/react-router';

import { discountScreen, discountSearch, loadDiscountMessages, loadDiscountScreens } from '@/modules/discount/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Desconto no caminho do legado (`router.tsx:1233-1239`, só com `DESCONTO_MENU === 1`): a flag e a permissão
// vão no manifesto. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/desconto/')({
  validateSearch: discountSearch,
  staticData: { screen: discountScreen },
  loader: () => loadDiscountMessages(),
  component: lazyScreen(loadDiscountScreens, 'DiscountRouteScreen'),
});
